import React from "react";
import "../../App.css";
import ExternalLink from "../ExternalLink";

function Home() {
  return (
    <div className="container px-4 px-lg-5">
      <div className="row gx-4 gx-lg-5 align-items-center my-5">
        <div className="col-lg-4">
          <img
            className="img-fluid rounded mb-4 mb-lg-0 mx-auto d-block"
            src="./portrait.jpg"
            alt="Portrait"
          />
        </div>

        <div className="col-lg-8">
          <h1 className="font-weight-light">Individuelle CAD-Schulungen</h1>

          <p style={{ fontSize: "1.3rem", marginBottom: "1.3rem" }}>
            Ich biete praxisnahe CAD-Schulungen, die konsequent auf die
            jeweiligen Teilnehmer zugeschnitten sind. Inhalte, Tiefe und
            Schwerpunkte orientieren sich an realen Aufgabenstellungen – auch
            über den eigentlichen Schulungsrahmen hinaus. Präsenz- und
            Online-Trainings sind gleichermaßen möglich.
          </p>

          <a className="btn btn-primary" href="/kontakt">
            Kontaktieren Sie mich hier!
          </a>
        </div>
      </div>

      <div className="card text-white bg-secondary my-5 py-2 text-center">
        <div className="card-body">
          <p className="text-white m-0" style={{ fontSize: "2rem" }}>
            Schulungen in Präsenz oder Online!
          </p>
        </div>
      </div>

      <div className="row gx-4 gx-lg-4">
        {/* Siemens NX */}
        <div className="col-md-4 mb-5">
          <div className="card h-100">
            <div className="card-body">
              <h2 className="card-title">Siemens NX</h2>
              <p className="card-text">
                Dieses High-End CAD-System von Siemens kann die komplette
                Prozesskette einer Firma abdecken. Mein Favorit für
                Freiformflächen und synchrone Konstruktion.
              </p>
            </div>
            <div className="card-footer d-flex gap-2">
              <a className="btn btn-primary btn-sm" href="/nx">
                Schulungsdetails
              </a>
              <ExternalLink href="https://www.plm.automation.siemens.com/global/de/products/nx/">
                Zum Hersteller
              </ExternalLink>
            </div>
          </div>
        </div>

        {/* Solid Edge */}
        <div className="col-md-4 mb-5">
          <div className="card h-100">
            <div className="card-body">
              <h2 className="card-title">Solid Edge</h2>
              <p className="card-text">
                Dieses System ist besonders nutzerfreundlich und einfach zu
                bedienen. Vielseitig, aber etwas weniger mächtig verglichen mit
                NX.
              </p>
            </div>
            <div className="card-footer d-flex gap-2">
              <a className="btn btn-primary btn-sm" href="/solid-edge">
                Schulungsdetails
              </a>
              <ExternalLink href="https://solidedge.siemens.com/de/">
                Zum Hersteller
              </ExternalLink>
            </div>
          </div>
        </div>

        {/* SolidWorks */}
        <div className="col-md-4 mb-5">
          <div className="card h-100">
            <div className="card-body">
              <h2 className="card-title">SolidWorks</h2>
              <p className="card-text">
                Konkurrenzprodukt zu Solid Edge mit vergleichbarem
                Funktionsumfang. Das bekannteste Mid-Range System.
              </p>
            </div>
            <div className="card-footer d-flex gap-2">
              <a className="btn btn-primary btn-sm" href="/solid-works">
                Schulungsdetails
              </a>
              <ExternalLink href="https://www.solidworks.com/de">
                Zum Hersteller
              </ExternalLink>
            </div>
          </div>
        </div>

        <div className="spacer"></div>
      </div>
    </div>
  );
}

export default Home;
